<template>
	<div>
		<h2>{{ $t('labels.general.budget') }}</h2>
		<div class="btn-bar">
			<div class="btn-group-navigation">
				<router-link :to="{ name: 'UserProfileBudgetBudget' }">{{ $t('labels.general.budget') }}</router-link>
				<router-link :to="{ name: 'UserProfileBudgetAccountMovements' }">{{ $t('labels.general.account_movements') }}</router-link>
				<router-link :to="{ name: 'UserProfileBudgetPaymentMethods' }">{{ $t('labels.general.payment_methods') }}</router-link>
			</div>
			<div class="btn-group-operations">
				<button-icon-text-loading
					v-if="isRoute('UserProfileBudgetPaymentMethods')"
					@click.native="$emit('open-modal-add-payment')"
					icon="plus-w" class="plus btn-add">{{ $t('labels.general.add_payment_method') }}</button-icon-text-loading>
			</div>
		</div>
		<router-view/>
	</div>
</template>

<script>
export default {
	methods: {
		isRoute (route) {
			return this.$route.name === route
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/profile/Budget.vue